export default "__VITE_ASSET__isYoRhb5__"